import React from 'react';
import heroBanner from '../assets/img/banner.png';

function Solutions() {
    return (
        <div className="w-full">

            <div className="w-full flex flex-col md:flex-row">
                <div className="flex-1 relative order-1 md:order-2">
                    <div className="absolute inset-y-0 left-0 w-1/4 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none"></div>

                    <img src={heroBanner} alt="Hero Banner" className="relative z-0" />
                </div>


                {/* Left Section */}
                <div className="flex-1.4 flex justify-center order-2 md:order-1">
                    <div className="w-3.5/4  flex flex-col items-start justify-center sm:p-3 p-4">
                        <p className="font-medium leading-tight">
                            <span className="block sm:text-5xl text-3xl">Consulting &</span>
                            <span className="block sm:text-5xl text-3xl">Implementation</span>
                        </p>
                        <p>
                            Enhance customer satisfaction and loyalty through engaging and relevant customer experience.
                        </p>
                        <button className="bg-red text-white font-bold py-2 px-4 rounded-lg mt-5">
                            Book a consulting call
                        </button>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default Solutions;
